import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=e097c012&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e097c012')) {
      api.createRecord('e097c012', component.options)
    } else {
      api.reload('e097c012', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=e097c012&", function () {
      api.rerender('e097c012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ra4qKPI393ug/JS/comp/IncreaseNumber.vue"
export default component.exports